import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { HasPermissionService } from './has-permission.service';
import { UserRoles } from './constant.service';

@Injectable({
  providedIn: 'root',
})
export class ActivateMarketing  {
  constructor(
    private router: Router,
    private hasPermission: HasPermissionService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    var roles: UserRoles[] = [UserRoles.Marketing, UserRoles.SuperAdmin];
    return this.hasPermission.allowAccessAsync(roles, route);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return this.canActivate(route, state);
  }
}
